import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import UMOMediaView from '../UMOMediaView';
import MetadataView from '../MetadataView/MetadataView';
import piction from '../../utils/piction';
import Noty from 'noty';
import { SESSION_EXPIRED_MESSAGE } from '../../constants/sessionStateTypes';
import { sessionExpired } from '../../actions/session';
function CompareItem({
  umoID,
  dispatch,
  toggleWorkspaceDetailView,
  displayTwo,
  intl,
}) {
  const [umo, setUMOData] = useState(null);
  let requestPromise = null;
  useEffect(() => {
    requestPromise = piction
      .getUMOs(`UMO_ID:"${umoID}"`, {
        zoomify: 'true',
      })
      .then((res) => {
        if (res.umoList.all[0]) {
          const umoData = res.umoList.all[0];
          setUMOData(umoData);
        } else {
          setUMOData(null);
          new Noty({
            type: 'error',
            text: intl.formatMessage({ id: 'general.error' }),
          }).show();
          toggleWorkspaceDetailView(false);
        }
      })
      .catch((err) => {
        setUMOData(null);
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        }
        new Noty({
          type: 'error',
          text: intl.formatMessage({ id: 'general.error' }),
        }).show();
        toggleWorkspaceDetailView(false);
      });
    return () => {
      setUMOData(null);
      requestPromise.cancel();
    };
  }, [umoID]);

  return umo ?
    <div className={cn("compare-umos__item", displayTwo ? 'col-sm-6' : 'col-sm-4')}>
      <div className="workspace-detail-view__image">
        <div className="workspace-detail-view__image-display">
          <div className="workspace-detail-view__media umo-detail-view__image-display-hover">
            <UMOMediaView
              umo={umo}
              setIsMediaObj={() => {}}
              isZoomable={true}
            />
          </div>
        </div>
      </div>
      <div className="workspace-detail-view__body">
        <div className="workspace-detail-view__content">
          <div className="workspace-detail-view__content-title">{umo.name}</div>
        </div>
      </div>
      <MetadataView
        umo={umo}
        toggleUMODetailView={toggleWorkspaceDetailView}
        dispatch={dispatch}
      />
    </div>
  : null;
}

CompareItem.propTypes = {
  umoID: PropTypes.string,
  dispatch: PropTypes.func,
  toggleWorkspaceDetailView: PropTypes.func,
  displayTwo: PropTypes.bool,
};

export default CompareItem;
